import type { TDictionaryItem, TUser } from '../../../../api/types'
import type { UserDescription } from '../../../../types/entitys/users'

const dictionaryNames = (items?: TDictionaryItem[]): string[] =>
  (items ?? []).map((row) => row.name).filter((n) => n.trim().length > 0)

const objectValue = (value: unknown): Record<string, unknown> | null =>
  value != null && typeof value === 'object' && !Array.isArray(value)
    ? value as Record<string, unknown>
    : null

const matchingRemoteAllowed = (meta: TUser['meta']): boolean => {
  const recommendations = objectValue(meta?.recommendations)
  if (recommendations && 'remote_allowed' in recommendations) {
    return recommendations.remote_allowed === true
  }

  const matching = objectValue(meta?.matching)
  if (matching && 'remote_allowed' in matching) {
    return matching.remote_allowed === true
  }

  return false
}

/** Подстановка legacy `about`, если новые поля пусты (как на карточке профиля). */
const resolveDescriptionFields = (
  user: TUser
): Pick<UserDescription, 'description' | 'full_description'> => {
  const description = (user.description ?? '').trim()
  const fullDescription = (user.full_description ?? '').trim()
  const legacyAbout = (user.about ?? '').trim()

  if (!description && !fullDescription && legacyAbout) {
    if (legacyAbout.length <= 500) {
      return { description: legacyAbout, full_description: '' }
    }
    return { description: '', full_description: legacyAbout }
  }

  return {
    description: user.description ?? '',
    full_description: user.full_description ?? '',
  }
}

export const tUserToUserDescription = (user: TUser): UserDescription => ({
  id: user.id,
  slug: user.slug ?? '',
  name: user.name,
  surname: user.lastname,
  otch: user.patronymic ?? '',
  city: user.city,
  age: user.age,
  birthday: user.birthday?.trim() ? user.birthday.trim() : undefined,
  isOnline: user.is_online,
  status: user.status,
  slogan: user.slogan ?? '',
  ...resolveDescriptionFields(user),
  region: user.region ?? '',
  work: user.work ?? '',
  competencies: dictionaryNames(user.competencies),
  availableResources: dictionaryNames(user.resources),
  conditionsOfParticipation: dictionaryNames(user.participation),
  directionsOfDevelopment: dictionaryNames(user.improvements),
  image: user.avatar ?? '',
  meta: user.meta,
  matchingRemoteAllowed: matchingRemoteAllowed(user.meta),
})
